// utils
import { mapErrorsToModel } from '@/utils/api';

export const deleteOrder = async (id) => {
  return await window.axios
    .delete(`/orders/${id}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getOrders = async () => {
  return await window.axios
    .get('/orders?include=menu,deliveryAddress', {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getOrder = async (id) => {
  return await window.axios
    .get('/orders/' + id, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const storeOrder = async (attributes) => {
  return await window.axios
    .post('orders', {
      data: {
        type: 'orders',
        attributes,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 422) {
        return mapErrorsToModel(error.response.data.errors);
      }
      return error.response.data;
    });
};

export const exportOrder = async (menuId) => {
  return await window.axios.get('/menu-pdf/' + menuId + '/qualityPreview').then((data) => {
    return data.data;
  });
};
